import { render, staticRenderFns } from "./product-receive-table.vue?vue&type=template&id=72030e6a&scoped=true&"
import script from "./product-receive-table.vue?vue&type=script&lang=js&"
export * from "./product-receive-table.vue?vue&type=script&lang=js&"
import style0 from "./product-receive-table.vue?vue&type=style&index=0&id=72030e6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72030e6a",
  null
  
)

export default component.exports